<template>
	<Bubble :data="data" :options="options" />
</template>

<script>
import { Bubble } from 'vue-chartjs'
import { useChart } from '@/composables/useChart'

const BubbleChart = {
	props: ['data', 'options'],
	components: { Bubble },
	setup () {
		useChart()
	}
}

export default BubbleChart
export { BubbleChart as mdbBubbleChart }
</script>
